module.exports = __webpack_public_path__ + "static/media/b16.8b2e101c.png";